'use client';

import type { DailyBonusCardItem } from '@/components/entities/dailyBonus/hooks/useDailyBonusRewards';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useDailyBonusRewards } from '@/components/entities/dailyBonus/hooks/useDailyBonusRewards';
import { playerGamificationRewardsOptions } from '@/queries/playerGamificationRewards/playerGamificationRewards.queries';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

const isDailyRewardAvailable = ({ state, onClick }: DailyBonusCardItem) => state === 'ready' && typeof onClick === 'function';

export const useUnclaimedGamificationRewardsCount = () => {
  const { cards: dailyRewards } = useDailyBonusRewards();
  const { data: groupedRewards } = useQuery(playerGamificationRewardsOptions.meGroupedRewards());

  return useMemo(() => {
    const rewardsCount = {
      totalRewards: 0,
      statusUpRewards: 0,
      levelUpRewards: 0,
    };

    groupedRewards?.forEach((rewardGroup) => {
      rewardsCount.totalRewards += rewardGroup.availableAmount;

      if (rewardGroup.type === GamificationRewardType.StatusUp) {
        rewardsCount.statusUpRewards += rewardGroup.availableAmount;
      }

      if (rewardGroup.type === GamificationRewardType.LevelUp) {
        rewardsCount.levelUpRewards += rewardGroup.availableAmount;
      }
    });

    const availableDailyRewards = dailyRewards.filter(isDailyRewardAvailable);

    rewardsCount.totalRewards += availableDailyRewards.length;

    return rewardsCount;
  }, [groupedRewards, dailyRewards]);
};
